<template>
  <div class="profile-page page">
    <div class="profile-page__title">Профиль агента</div>
    <div v-if="agent" class="profile-page__info">
      <div class="profile-page__item">
        <div class="profile-page__item-title">
          {{ $t('info_for_manager.contact_person') }} / ФИО
          <button class="profile-page__item-edit" @click="editAgent">
            <img :src="getPic(locale)" alt="Edit" />
          </button>
        </div>
        <div class="profile-page__item-row">
          <div class="profile-page__item-name">
            {{ $t('business_account_data.full_name') }}
          </div>
          <div class="profile-page__item-value">
            {{ agent.fio || '-' }}
          </div>
        </div>
        <div class="profile-page__item-row">
          <div class="profile-page__item-name">
            {{ $t('business_account_data.inn') }}
          </div>
          <div class="profile-page__item-value">
            {{ agent.inn || '-' }}
          </div>
        </div>
      </div>
      <div class="profile-page__item">
        <div class="profile-page__item-title">
          {{ $t('profile.bank_details') }}
          <button class="profile-page__item-edit" @click="editAgent">
            <img :src="getPic(locale)" alt="Edit" />
          </button>
        </div>
        <div class="profile-page__item-row">
          <div class="profile-page__item-name">
            {{ $t('profile.bank_name') }}
          </div>
          <div class="profile-page__item-value">
            {{ agent.bank_name || '-' }}
          </div>
        </div>
        <div v-if="locale === 'RU'" class="profile-page__item-row">
          <div class="profile-page__item-name">
            {{ $t('profile.bic') }}
          </div>
          <div class="profile-page__item-value">
            {{ agent.bic || '-' }}
          </div>
        </div>
        <div v-if="locale === 'RU'" class="profile-page__item-row">
          <div class="profile-page__item-name">
            {{ $t('profile.сhecking_account') }}
          </div>
          <div class="profile-page__item-value">
            {{ agent.iban || '-' }}
          </div>
        </div>
        <div class="profile-page__item-row">
          <div class="profile-page__item-name">
            {{ $t('profile.bank_address') }}
          </div>
          <div class="profile-page__item-value">
            {{ agent.bank_address || '-' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentProfile',
  data() {
    return {
      locale: process.env.VUE_APP_LOCALE,
    };
  },
  computed: {
    user() {
      return this.$store.state.Auth.user;
    },
    agent() {
      // Сначала проверяем user.agent, если нет - берем из editAgent
      return this.$store.state.Auth.user?.agent || this.$store.state.Referrals.editAgent;
    },
    role() {
      return this.$store.state.Auth.role;
    },
  },
  methods: {
    getPic(locale) {
      if (locale === 'RU') {
        return require('@/assets/icons/icon-edit.svg');
      } else {
        return require('@/assets/icons/icon-edit-red.svg');
      }
    },
    editAgent() {
      this.$store.commit('Dialog/setData', { label: 'isEditable', data: true });
      this.$store.commit('Referrals/setData', { label: 'editAgent', data: this.agent });
      this.$store.commit('Dialog/setData', { label: 'activeDialog', data: 'ReferralData' });
      this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: true });
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

.profile-page {
  &__title {
    font-size: 3rem;
    font-weight: 700;
    line-height: 3.5rem;
    margin-bottom: 3rem;
    display: flex;
    justify-content: space-between;
  }

  &__item {
    margin-bottom: 4rem;

    &:last-of-type {
      margin-bottom: 0;
    }

    &-title {
      display: flex;
      align-items: center;
      font-size: 1.6rem;
      font-weight: 700;
      line-height: 1.9rem;
      margin-bottom: 2rem;
    }

    &-edit {
      background: none;
      border: none;
      margin-left: 1.4rem;
      cursor: pointer;

      img {
        display: block;
      }
    }

    &-row {
      display: flex;
      align-items: flex-start;
      font-size: 1.6rem;
      line-height: 1.9rem;
      margin-bottom: 1.8rem;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    &-name {
      color: $grey1;
      padding-right: 2rem;
      min-width: 200px;
    }

    &-value {
      color: $basicBlack;
    }
  }
}

@include below(769px) {
  .profile-page {
    &__title {
      flex-direction: column;
      gap: 1rem;
    }
  }
  .profile-page__item-row {
    flex-direction: column;
  }
  .profile-page__item-name {
    width: 100%;
    padding-right: 0;
    margin-bottom: 5px;
  }
}
</style>
